// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QH-z","hovered":"RH-z","hoverImage":"SH-z","mainImage":"TH-z","imageNoBackground":"UH-z","fullSizeImage":"VH-z"};